import api from './api';
import { API_CONFIG } from '../config/api';

export const scraperConfigAPI = {
  // Configurações de Site
  async getSiteConfigs(params = {}) {
    const response = await api.get('/scraper/config/site', { params });
    return response.data;
  },

  async getSiteConfig(id) {
    const response = await api.get(`/scraper/config/site/${id}`);
    return response.data;
  },

  async createSiteConfig(data) {
    const response = await api.post('/scraper/config/site', data);
    return response.data;
  },

  async updateSiteConfig(id, data) {
    const response = await api.put(`/scraper/config/site/${id}`, data);
    return response.data;
  },

  async deleteSiteConfig(id) {
    const response = await api.delete(`/scraper/config/site/${id}`);
    return response.data;
  },

  async getConfigByDomain(domain) {
    const response = await api.get(`/scraper/config/by-domain/${domain}`);
    return response.data;
  },

  // Configurações Globais
  async getGlobalConfigs() {
    const response = await api.get('/scraper/config/global');
    return response.data;
  },

  async createGlobalConfig(data) {
    const response = await api.post('/scraper/config/global', data);
    return response.data;
  },

  async updateGlobalConfig(id, data) {
    const response = await api.put(`/scraper/config/global/${id}`, data);
    return response.data;
  },

  async deleteGlobalConfig(id) {
    const response = await api.delete(`/scraper/config/global/${id}`);
    return response.data;
  },

  // Utilitários
  async testSelectors(data) {
    const response = await api.post('/scraper/config/test', data);
    return response.data;
  },

  async autoDetectSelectors(data) {
    const response = await api.post('/scraper/config/auto-detect', data);
    return response.data;
  },

  // ⚠️ MÉTODOS ANTIGOS REMOVIDOS - USAR startSmartScraping
  // async scrapeBatchEnhanced(data) { // REMOVIDO
  // async scrapeQuick(data) { // REMOVIDO

  // Background scraping
  async startBackgroundScraping(urls) {
    const response = await api.post('/scraper/background/start', { urls });
    return response.data;
  },

  // Smart scraping with global cache
  async startSmartScraping(urls, tags = [], options = {}) {
    const response = await api.post('/scraper/background/smart-scraping', {
      urls,
      tags,
      ...options
    }, {
      timeout: API_CONFIG.SCRAPING_START_TIMEOUT
    });
    return response.data;
  },

  async getJobStatus(jobId) {
    const response = await api.get(`/scraper/background/status/${jobId}`);
    return response.data;
  },

  async getUserJobs() {
    const response = await api.get('/scraper/background/jobs');
    return response.data;
  },

  async checkDuplicateUrls(urls) {
    // Lotes grandes podem exigir várias consultas ao banco. Este timeout evita que
    // o frontend abandone silenciosamente a verificação e trate todos como novos.
    const response = await api.post(
      '/scraper/background/check-duplicates',
      { urls },
      { timeout: 120000 }
    );
    return response.data;
  }
};
